<template>
  <MainLayout
    :auth="auth"
    :isMobile="isMobile"
  >
    <router-view />
  </MainLayout>
</template>

<script>
import MainLayout from "@/profile/components/layout/MainLayout";
import router from "@/profile/router";
import {getMetrikaClientId } from "@/profile/composables/utils";

export default {
  name: "App",
  data: () => {
    return {
      selected_menu: "",
      roles: "",
      contract_number: "",
      token: null,
      auth: true
    };
  },
  computed: {
    isMobile() { // f5 для применения изменений
      return window.innerWidth <= 768;
    }
  },
  async beforeMount() {
    //Подписываемся на изменение ролей
    this.$myApp.role.on((value) => {
      this.roles = value;
    });
    //Подписываемся на шаблона авторизации
    this.$myApp.auth.on((value) => {
      this.auth = value;
    });
    //Получаем токен из хранилища
    this.token = window.localStorage.getItem("token");
    if (this.token !== null) {
      //Проставляем токен в глобальное хранилище
      this.$myApp.token.set(this.token);
    }
    this.$myApp.yandex_id.set(getMetrikaClientId());
    console.log(this.$myApp.yandex_id.get());
    //При каждом переходе согласовуем
    router.beforeEach((to, from, next) => {
      if (to.query.code && to.query.state && to.fullPath.includes("esia")) {
        // console.log(`router.beforeEach 0`);
        this.cdpAuth(to.query.code, to.query.state);
      } else if (to.query.code && to.query.state && !to.fullPath.includes("esia")) {
        // console.log(`router.beforeEach 1`);
        this.tbankAuth2(to.query.code, to.query.state);
      } else if (to.name === "load") {
        // console.log(`router.beforeEach 2`);
        let api = this.$apipa.get({
          command: "mob_get_token_data"
          // url_token: url_string[5],
        });
        if (api.error) {
          this.errors = [];
          this.errors = api.errors;
          if (api.errors[0] === "Токен не указан") {
            alert("Недоступно");
          }
          alert("Ошибка");
        }
        if (api.success) {
          this.$myApp.token.set(api.data.token);
          window.localStorage.setItem("token", api.data.token);
          this.$router.push({ name: "contracts" });
        }
      } else if (this.$route.params.token) {
        // console.log(`router.beforeEach 3`);
        this.$router.push({
          name: "contractForB2B",
          params: {
            id: this.$route.params.id,
            token: this.$route.params.token
          }
        });
      } else if (to.name === "forgot" || to.name === "signin") {
        // console.log(`router.beforeEach 4`);
        next();
      } else {
        // console.log(`router.beforeEach 5`);
        this.checkToken(to);
        next();
      }
    });
  },
  created() {
    document.title = "Личный кабинет клиента";
  },
  methods: {
    //аутентицикация с цифровым профилем гражданина(citizen digital profile -> cdp)
    async cdpAuth(code, state) {
      this.$myApp.errors.reset();
      this.$myApp.token.set(window.localStorage.getItem("token"));
      let params = {
        action: "esia-auth",
        object: "cpa",
        code: code,
        state: state,
        token: this.$myApp.token.get()
      };
      this.$myApp.actions.set(params.action);
      let api = await this.$api2.get(params);
      this.$myApp.actions.pullout(params.action);
      console.log(api);
      
      if (api.success) {
        if (api.data.menu) {
          this.$myApp.menu.set(api.data.menu);
        }
        if (api.data.roles) {
          this.$myApp.role.set(api.data.roles);
        }
        if (api.data.names) {
          this.$myApp.name.set(
            api.data.names.first_name + " " + api.data.names.last_name
          );
        }
        this.$myApp.auth.set(false);
        this.$router.push({ name: "contracts" });
      }
      if (api.error) {
        if (api.error_code === 8013) {
          this.$myApp.errors.set("Пользователь не найден, воспользуйтесь другим способом авторизации");
        } else if (api.error_code === undefined) {
          this.$myApp.errors.set("Личный кабинет не найден, пройдите регистрацию в Личном кабинете МАКС-Жизнь");
        } else {
          this.$myApp.errors.set(api.errors);
        }
        this.$router.push({ name: "login" });
      }
    },
    async tbankAuth2(code, state) {
      this.$myApp.errors.reset();
      this.$myApp.token.set(window.localStorage.getItem("token"));
      let params = {
        action: "tbank-auth",
        object: "cpa",
        code: code,
        state: state,
        token: this.$myApp.token.get()
      };
      this.$myApp.actions.set(params.action);
      let api = await this.$api2.get(params);
      this.$myApp.actions.pullout(params.action);

      if (api.success) {
        // console.log(api);
        if (api.data.menu) {
          this.$myApp.menu.set(api.data.menu);
        }
        if (api.data.roles) {
          this.$myApp.role.set(api.data.roles);
        }
        if (api.data.names) {
          this.$myApp.name.set(
            api.data.names.first_name + " " + api.data.names.last_name
          );
        }
        this.$myApp.auth.set(false);
        this.$router.push({ name: "contracts" });
      }
      if (api.error) {
        // console.log(api.error_code);
        if (api.error_code === 8013) { // есть счёт в т-банке, но нет в Макс-Жизнь
          this.$myApp.errors.set("Личный кабинет не найден, пройдите регистрацию в Личном кабинете МАКС-Жизнь");
        } else if (api.error_code === 8015) { // нет счёта в т-банке
          this.$myApp.errors.set("Пользователь не найден, воспользуйтесь другим способом авторизации");
        } else {
          this.$myApp.errors.set(api.errors);
        }
        this.$router.push({ name: "login" });
      }
    },
    //Проверка токена
    async checkToken(to) {
      let params = {};
      if (this.token === null) {
        params = {
          action: "get-token",
          object: "cpa"
        };
      } else { // Параметры для создания токен
        params = {
          action: "get-token",
          object: "cpa",
          app_token: this.token
        };
      } //Параметры для обновления токена
      this.$myApp.actions.set(params.action);
      let api = await this.$api2.get(params);
      this.$myApp.actions.pullout(params.action);
      // console.log(`App checkToken this.$route`,this.$route);
      if (api.success) {
        let d = new Date();
        d.setTime(d.getTime() + 300);
        let expires = "expires=" + d.toUTCString();
        document.cookie = "token" + "=" + api.data.token + ";" + expires + ";path=/";
        this.token = api.data.token;
        window.localStorage.setItem("token", api.data.token);
        this.$myApp.token.set(api.data.token);
        if (api.data.need_auth === true) {
          this.$myApp.auth.set(true);
          this.$router.push({ name: "login" });
        } else {
          if (api.data.auth_type === "TEMP") {
            this.$myApp.auth.set(true);
            this.$router.push("changepass");
          } else {
            if (to.name !== "login") {
              this.$myApp.auth.set(false);
              // this.$router.push({ name: "contracts" });
            }
            if (to.name === "home") {
              this.$router.push({ name: "contracts" });
            }
          }
          if (api.data.menu) {
            this.$myApp.menu.set(api.data.menu);
          }
          if (api.data.roles) {
            this.$myApp.role.set(api.data.roles);
          }
          if (api.data.names) {
            this.$myApp.name.set(
              api.data.names.first_name + " " + api.data.names.last_name
            );
          }
        }
      }
    }
  },
  components: {
    MainLayout
  }
};
</script>
<style>
.form .fld {
  width: 12em;
  margin: 1em;
  display: inline-block;
}

.box > input + label + input {
  display: none;
}

.alert {
  white-space: pre-wrap;
}

.alert.alert-success,
.box > input:checked + label {
  color: #007700;
}

.alert.alert-danger {
  color: #770000;
}

.box > input:checked + label + input {
  display: inline-block;
  padding: 0.25em;
  font-size: 100%;
}

.form button {
  float: right;
}

.form button:disabled {
  background: #4a4a4a;
}

.form-label {
  display: inline-block;
  width: 15em;
}

#prolongation_sendSMS_alert .message-fixed {
  position: fixed;
  z-index: 40;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(33, 35, 37, 0.5);
  overflow: auto;
}

#prolongation_sendSMS_alert .message-flex {
  padding: 41px 40px 40px;
  width: 558px;
  background: #fff;
  margin: 30vh auto;
}

#prolongation_sendSMS_alert .message-title {
  font-size: 20px;
  color: #212325;
}

#prolongation_sendSMS_alert .message-body {
  font-size: 16px;
  font-weight: 400;
  color: #212325;
  text-align: justify;
}

#prolongation_sendSMS_alert button,
#prolongation_sendSMS,
#prolongation_checkCode {
  width: 400px;
  float: right;
  margin: 0 0 0 -400px;
  padding: 10px;
  background: #0062cc;
  color: #ffffff;
  border: 2px solid #005cbf;
  outline: #0075d4;
  cursor: pointer;
  font: 700 20px SourceSansPro, sans-serif;
  border-radius: 0.3rem;
}

#prolongation_sendSMS:disabled,
#prolongation_checkCode:disabled {
  color: #212529;
  background-color: #dae0e5;
  border-color: #d3d9df;
  cursor: auto;
}

input[name="chart_date_period"],
input[name="chart_date_format"] {
  display: none;
}

.chart_date_period_button {
  color: #007bff;
  background-color: #007bff;
  border-color: #007bff;
}

.chart_date_format_button {
  color: #28a745;
  background-color: #28a745;
  border-color: #28a745;
}

.chart_date_format_button.selected,
.chart_date_period_button.selected {
  color: #fff;
}

.chart_date_format_button:not(.selected),
.chart_date_period_button:not(.selected) {
  background-color: #fff;
}

.label_chart_button {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border: 1px solid;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
  border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.main-user-data .user-data-polices .user-data-polices-group .polices-header {
  margin-top: 48px;
}

.main-user-data .user-data-polices .user-data-polices-group .polices-list {
  margin-top: 16px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  width: 100%;
}

.main-user-data .user-data-polices .user-data-polices-group .polices-list .policy {
  width: calc(50% - 16px);
  margin-top: 32px;
  border: 1px solid #e5e5e5;
  padding: 24px;
  -webkit-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  -webkit-box-shadow: inset 1px 1px 0 0 #e5e5e5, inset -1px -1px 0 0 #e5e5e5;
  box-shadow: inset 1px 1px 0 0 #e5e5e5, inset -1px -1px 0 0 #e5e5e5;
  position: relative;
}

.main-user-data .user-data-polices .user-data-polices-group .polices-list .policy .policy-header {
  margin-bottom: 24px;
}

.main-user-data .user-data-polices .user-data-polices-group .polices-list .policy .policy-groupdata .policy-groupdata-header {
  font-weight: 400;
  color: #6e747a;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 4px;
}

.main-user-data .user-data-polices .user-data-polices-group .polices-list .policy .policy-groupdata .policy-groupdata-value {
  margin-bottom: 16px;
}

.main-user-data .user-data-polices .user-data-polices-group .polices-list .policy .policy-btn {
  margin-top: 8px;
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  color: #004b88;
}

.main-user-data .user-data-polices .user-data-polices-group .polices-list .policy:hover {
  -webkit-box-shadow: inset 1px 1px 0 0 transparent, inset -1px -1px 0 0 transparent, 0 20px 22px -10px rgba(0, 0, 0, .2);
  box-shadow: inset 1px 1px 0 0 transparent, inset -1px -1px 0 0 transparent, 0 20px 22px -10px rgba(0, 0, 0, .2);
  cursor: pointer;
}

@media only screen and (max-width: 579px) {
  .main-user-data .user-data-polices .user-data-polices-group .polices-list {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
  }

  .main-user-data .user-data-polices .user-data-polices-group .polices-list .policy {
    width: 100%;
  }
}

.main-user-data .detail-policy-info .policy-accardion {
  min-height: 77px;
  background: #fff;
  border: 1px solid #e5e5e5;
  /*cursor: pointer;*/
  -webkit-transition: 0.4s;
  -o-transition: 0.4s;
  transition: 0.4s;
  margin-bottom: 100px;
}

.main-user-data .detail-policy-info .policy-accardion .policy-accardion-header {
  padding: 24px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  cursor: pointer;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.main-user-data .detail-policy-info .policy-accardion .policy-accardion-header .policy-accardion-title {
  font-size: 24px;
  color: #212325;
  font-weight: 700;
}

@media only screen and (max-width: 768px) {
  .main-user-data .detail-policy-info .policy-accardion .policy-accardion-header .policy-accardion-title {
    font-size: 18px;
    padding-right: 15px;
  }
}

.main-user-data .detail-policy-info .policy-accardion .policy-accardion-header .iconActive {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  transform: rotate(180deg);
}

.main-user-data .detail-policy-info .policy-accardion .policy-accardion-header .authorization-close-btn {
  margin-top: auto;
}

.main-user-data .detail-policy-info .policy-accardion .show-content {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  width: 100%;
  height: auto;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-flow: row wrap;
  -ms-flex-flow: row wrap;
  flex-flow: row wrap;
  background-color: #fff;
  padding: 0 24px;
}

.main-user-data .detail-policy-info .policy-accardion .show-content .show-item {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  margin: 16px 0;
}

.main-user-data .detail-policy-info .policy-accardion .show-content .show-item .show-title {
  font-size: 16px;
  color: #6e747a;
  line-height: 24px;
  font-weight: 400;
}

.main-user-data .detail-policy-info .policy-accardion .show-content .show-item .show-text {
  font-weight: 400;
  font-size: 20px;
  color: #494e52;
  line-height: 34px;
}

@media only screen and (max-width: 579px) {
  .main-user-data .detail-policy-info .policy-accardion .show-content .show-item .show-title {
    font-size: 8px;
  }

  .main-user-data .detail-policy-info .policy-accardion .show-content .show-item .show-text {
    font-size: 12px;
  }
}

.main-user-data .detail-policy-info .policy-accardion .submit-btn-block-accept {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: end;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  width: 100%;
  height: auto;
  padding: 16px 24px;
  background-color: #fff;
}

.main-user-data .detail-policy-info .policy-accardion .accardion-content {
  display: none;
  margin: 0 24px;
}

.main-user-data .detail-policy-info .policy-accardion .accardion-content .policy-accardion-items-row {
  -webkit-flex-flow: row wrap;
  -ms-flex-flow: row wrap;
  flex-flow: row wrap;
  font-weight: 700;
  font-size: 20px;
  color: #494e52;
}

.main-user-data .detail-policy-info .policy-accardion .accardion-content .policy-accardion-items-row, .main-user-data .detail-policy-info .policy-accardion .accardion-content .policy-accardion-items-row .policy-accardion-items-row-item {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  width: 100%;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: start;
  -webkit-align-items: flex-start;
  -ms-flex-align: start;
  align-items: flex-start;
}

.main-user-data .detail-policy-info .policy-accardion .accardion-content .policy-accardion-items-row .policy-accardion-items-row-item {
  height: auto;
}

.main-user-data .detail-policy-info .policy-accardion .accardion-content .policy-accardion-items-row .policy-accardion-items-row-item .policy-accardion-items-text {
  height: auto;
  margin: 16px 8px;
  font-weight: 400;
  font-size: 20px;
  color: #494e52;
  line-height: 34px;
  text-align: center;
}

.main-user-data .detail-policy-info .policy-accardion .accardion-content .policy-accardion-items-row .policy-accardion-items-row-item .policy-accardion-items-text:first-child {
  text-align: left;
}

.main-user-data .detail-policy-info .policy-accardion .accardion-content .policy-accardion-items-row .policy-accardion-items-row-item .policy-accardion-items-text:last-child {
  text-align: right;
}

@media only screen and (max-width: 579px) {
  .main-user-data .detail-policy-info .policy-accardion .accardion-content .policy-accardion-items-row .policy-accardion-items-row-item .policy-accardion-items-text {
    font-size: 8px;
    line-height: 14px;
  }
}

@media only screen and (max-width: 579px) {
  .main-user-data .detail-policy-info .policy-accardion .accardion-content .policy-accardion-items-row {
    font-size: 8px;
  }
}

.main-user-data .detail-policy-info .policy-accardion .accardion-content .policy-accardion-items-column {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  height: auto;
}

.main-user-data .detail-policy-info .policy-accardion .accardion-content .policy-accardion-items-column .policy-accardion-items-text {
  font-weight: 400;
  font-size: 20px;
  color: #494e52;
  line-height: 34px;
  margin: 10px 0;
}

@media only screen and (max-width: 579px) {
  .main-user-data .detail-policy-info .policy-accardion .accardion-content .policy-accardion-items-column .policy-accardion-items-text {
    font-size: 8px;
    line-height: 14px;
  }
}

.main-user-data .detail-policy-info .policy-accardion .accardion-content .policy-accardion-items-header {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: start;
  -webkit-align-items: flex-start;
  -ms-flex-align: start;
  align-items: flex-start;
}

.main-user-data .detail-policy-info .policy-accardion .accardion-content .policy-accardion-items-header .policy-accardion-items-title {
  font-weight: 700;
  font-size: 20px;
  color: #494e52;
  margin: 0 8px 16px 0;
  text-align: center;
}

.main-user-data .detail-policy-info .policy-accardion .accardion-content .policy-accardion-items-header .policy-accardion-items-title:first-child {
  text-align: left;
}

.main-user-data .detail-policy-info .policy-accardion .accardion-content .policy-accardion-items-header .policy-accardion-items-title:last-child {
  text-align: right;
}

@media only screen and (max-width: 579px) {
  .main-user-data .detail-policy-info .policy-accardion .accardion-content .policy-accardion-items-header .policy-accardion-items-title {
    font-size: 8px;
  }
}

.main-user-data .detail-policy-info .policy-accardion .accardion-content .policy-accardion-items {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: start;
  -webkit-align-items: flex-start;
  -ms-flex-align: start;
  align-items: flex-start;
}

.main-user-data .detail-policy-info .policy-accardion .accardion-content .policy-accardion-items .policy-accardion-items-text {
  font-weight: 400;
  font-size: 20px;
  color: #494e52;
  line-height: 34px;
  margin: 10px 0;
  text-align: center;
}

.main-user-data .detail-policy-info .policy-accardion .accardion-content .policy-accardion-items .policy-accardion-items-text:first-child {
  text-align: left;
}

.main-user-data .detail-policy-info .policy-accardion .accardion-content .policy-accardion-items .policy-accardion-items-text:last-child {
  text-align: right;
}

.main-user-data .detail-policy-info .policy-accardion .accardion-content .policy-accardion-items .policy-accardion-items-text input[type=checkbox]:checked {
  background-color: #850033;
}

.main-user-data .detail-policy-info .policy-accardion .accardion-content .policy-accardion-items .pay-item {
  margin: 0;
}

@media only screen and (max-width: 579px) {
  .main-user-data .detail-policy-info .policy-accardion .accardion-content .policy-accardion-items .policy-accardion-items-text {
    font-size: 8px;
    line-height: 14px;
  }

  .main-user-data .detail-policy-info .policy-accardion .accardion-content .policy-accardion-items .policy-accardion-items-text .checkbox-label {
    padding-left: 22px;
    font-size: 8px;
  }
}

.main-user-data .detail-policy-info .policy-accardion .accardion-content .policy-accardion-items-row-item:nth-child(odd), .main-user-data .detail-policy-info .policy-accardion .accardion-content .policy-accardion-items:nth-child(odd) {
  background-color: #f5f5f5;
}

.main-user-data .detail-policy-info .policy-accardion .accardion-content .submit-btn-block {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: end;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  width: 100%;
  height: auto;
}

.main-user-data .detail-policy-info .policy-accardion .accardion-content .submit-btn-block .error-text {
  font-size: 16px;
  font-weight: 400;
  color: red;
  margin-right: 24px;
}

.main-user-data .detail-policy-info .policy-accardion .accardion-content .submit-btn-block .form-status-sending {
  position: relative;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  white-space: nowrap;
  margin-top: 48px;
}

@media only screen and (max-width: 1023px) {
  .main-user-data .detail-policy-info .policy-accardion .accardion-content .submit-btn-block .form-status-sending {
    right: auto;
  }
}

.main-user-data .detail-policy-info .policy-accardion .accardion-content .submit-btn-block .form-status-sending .form-loader {
  width: 36px;
  height: 36px;
  background-image: url(data:image/svg+xml;base64,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);
  -webkit-background-size: cover;
  background-size: cover;
  -webkit-animation: loading 0.5s infinite linear;
  animation: loading 0.5s infinite linear;
}

.main-user-data .detail-policy-info .policy-accardion .accardion-content .submit-btn-block .form-status-sending .form-loader-text {
  font-size: 16px;
  font-weight: 700;
  color: #004b88;
  margin-left: 8px;
}

@-webkit-keyframes loading {
  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn);
  }
}

.main-user-data .detail-policy-info .policy-accardion .accardion-content .submit-btn-block .common-button {
  font-weight: 700;
  font-size: 16px;
  color: #212325;
  line-height: 20px;
  background: #fff;
  border: 1px solid #d4d4d4;
  margin-top: 24px;
}

.main-user-data .detail-policy-info .policy-accardion .accardion-content .submit-btn-block .lightblue {
  background-color: #0075d4;
  color: #fff;
}

.main-user-data
.detail-policy-info
.policy-accardion
.accardion-content
.submit-btn-block
.disabled {
  background-color: #b3bdc7;
  color: #fff;
}

.main-user-data .detail-policy-info .policy-accardion .pay-title {
  font-size: 20px;
  color: #212325;
  font-weight: 700;
  margin-bottom: 24px;
}

.main-user-data .detail-policy-info .policy-accardion .error {
  border-color: red;
}

.main-user-data
.detail-policy-info
.policy-accardion
.accardion-content-active {
  display: block;
  margin-bottom: 24px;
}

.main-user-data .detail-policy-info .policy-accardion .detail-payment {
  position: fixed;
  z-index: 40;
  top: 0;
  left: 0;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-flow: row nowrap;
  -ms-flex-flow: row nowrap;
  flex-flow: row nowrap;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: start;
  -webkit-align-items: flex-start;
  -ms-flex-align: start;
  align-items: flex-start;
  padding-top: 100px;
  width: 100vw;
  height: 100vh;
  background-color: rgba(33, 35, 37, 0.5);
  overflow-y: auto;
  margin-bottom: 24px;
}

.main-user-data
.detail-policy-info
.policy-accardion
.detail-payment
.policy-accardion {
  -webkit-transition: 0.4s;
  -o-transition: 0.4s;
  transition: 0.4s;
  margin-bottom: 56px;
}

.main-user-data
.detail-policy-info
.policy-accardion
.detail-payment
.policy-accardion
.policy-accardion-header {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.main-user-data
.detail-policy-info
.policy-accardion
.detail-payment
.policy-accardion
.policy-accardion-header
.policy-accardion-title {
  font-size: 24px;
  color: #212325;
  font-weight: 700;
}

.main-user-data
.detail-policy-info
.policy-accardion
.detail-payment
.policy-accardion
.policy-accardion-header
.iconActive {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  transform: rotate(180deg);
}

@media only screen and (max-width: 579px) {
  .main-user-data
  .detail-policy-info
  .policy-accardion
  .detail-payment
  .policy-accardion
  .policy-accardion-header {
    padding: 24px 0;
  }
}

.main-user-data
.detail-policy-info
.policy-accardion
.detail-payment
.policy-accardion
.accardion-content {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  height: auto;
  padding: 0;
  margin: 0 6px;
  background-color: #fff;
}

.main-user-data
.detail-policy-info
.policy-accardion
.detail-payment
.policy-accardion
.accardion-content
.policy-accardion-items-row {
  -webkit-flex-flow: row wrap;
  -ms-flex-flow: row wrap;
  flex-flow: row wrap;
  font-weight: 700;
  font-size: 20px;
  color: #494e52;
}

.main-user-data
.detail-policy-info
.policy-accardion
.detail-payment
.policy-accardion
.accardion-content
.policy-accardion-items-row,
.main-user-data
.detail-policy-info
.policy-accardion
.detail-payment
.policy-accardion
.accardion-content
.policy-accardion-items-row
.policy-accardion-items-row-item {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  width: 100%;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: start;
  -webkit-align-items: flex-start;
  -ms-flex-align: start;
  align-items: flex-start;
}

.main-user-data
.detail-policy-info
.policy-accardion
.detail-payment
.policy-accardion
.accardion-content
.policy-accardion-items-row
.policy-accardion-items-row-item {
  min-height: 100px;
  height: auto;
}

.main-user-data
.detail-policy-info
.policy-accardion
.detail-payment
.policy-accardion
.accardion-content
.policy-accardion-items-row
.policy-accardion-items-row-item
.policy-accardion-items-text {
  height: auto;
  margin: 16px 8px;
  font-weight: 400;
  font-size: 20px;
  color: #494e52;
  line-height: 34px;
  text-align: center;
}

.main-user-data
.detail-policy-info
.policy-accardion
.detail-payment
.policy-accardion
.accardion-content
.policy-accardion-items-row
.policy-accardion-items-row-item
.policy-accardion-items-text:first-child {
  text-align: left;
}

.main-user-data
.detail-policy-info
.policy-accardion
.detail-payment
.policy-accardion
.accardion-content
.policy-accardion-items-row
.policy-accardion-items-row-item
.policy-accardion-items-text:last-child {
  text-align: right;
}

@media only screen and (max-width: 579px) {
  .main-user-data
  .detail-policy-info
  .policy-accardion
  .detail-payment
  .policy-accardion
  .accardion-content
  .policy-accardion-items-row
  .policy-accardion-items-row-item
  .policy-accardion-items-text {
    font-size: 8px;
    line-height: 14px;
  }
}

.main-user-data
.detail-policy-info
.policy-accardion
.detail-payment
.policy-accardion
.accardion-content
.policy-accardion-items-row
.policy-accardion-items-row-item
.checkbox-wrapper {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  width: 100%;
  min-height: 28px;
}

.main-user-data
.detail-policy-info
.policy-accardion
.detail-payment
.policy-accardion
.accardion-content
.policy-accardion-items-row
.policy-accardion-items-row-item
.checkbox-wrapper
.checkbox {
  width: 28px;
  height: 28px;
}

.main-user-data
.detail-policy-info
.policy-accardion
.detail-payment
.policy-accardion
.accardion-content
.policy-accardion-items-row
.policy-accardion-items-row-item
.checkbox-wrapper
.policy-accardion-items-text {
  width: 28px;
  height: 28px;
  height: auto;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -webkit-align-items: flex-start;
  -ms-flex-align: start;
  align-items: flex-start;
  margin: 16px 8px;
  font-weight: 400;
  font-size: 20px;
  color: #494e52;
  line-height: 34px;
  position: absolute;
  top: 6px;
  left: 6px;
  height: 16px;
  width: 16px;
  background-color: #fff;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  border: 1px solid #b3bdc7;
  -webkit-transition: all 0.1s;
  -o-transition: all 0.1s;
  transition: all 0.1s;
}

@media only screen and (max-width: 579px) {
  .main-user-data
  .detail-policy-info
  .policy-accardion
  .detail-payment
  .policy-accardion
  .accardion-content
  .policy-accardion-items-row
  .policy-accardion-items-row-item
  .checkbox-wrapper
  .policy-accardion-items-text {
    font-size: 8px;
    line-height: 14px;
  }
}

.main-user-data
.detail-policy-info
.policy-accardion
.detail-payment
.policy-accardion
.accardion-content
.policy-accardion-items-row
.policy-accardion-items-row-item
.checkbox-wrapper
.policy-accardion-items-text:after {
  content: "";
  position: absolute;
  top: 2px;
  left: 4px;
  width: 3px;
  height: 6px;
  border-width: 0 2px 2px 0;
  border-style: solid;
  border-color: #b3bdc7;
  opacity: 0.2;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
  -webkit-transition: all 0.1s;
  -o-transition: all 0.1s;
  transition: all 0.1s;
}

@media only screen and (max-width: 579px) {
  .main-user-data
  .detail-policy-info
  .policy-accardion
  .detail-payment
  .policy-accardion
  .accardion-content
  .policy-accardion-items-row {
    font-size: 10px;
  }
}

.main-user-data
.detail-policy-info
.policy-accardion
.detail-payment
.policy-accardion
.accardion-content
.policy-accardion-items-column {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  height: auto;
}

.main-user-data
.detail-policy-info
.policy-accardion
.detail-payment
.policy-accardion
.accardion-content
.policy-accardion-items-column
.policy-accardion-items-text {
  font-weight: 400;
  font-size: 20px;
  color: #494e52;
  line-height: 34px;
  margin: 10px 0;
}

.main-user-data
.detail-policy-info
.policy-accardion
.detail-payment
.policy-accardion
.accardion-content
.policy-accardion-items-column
.policy-accardion-items-text
.checkbox-wrapper {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  width: 100%;
}

.main-user-data
.detail-policy-info
.policy-accardion
.detail-payment
.policy-accardion
.accardion-content
.policy-accardion-items-column
.policy-accardion-items-text
.checkbox-wrapper
.checkbox {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 28px;
  height: 28px;
}

.main-user-data
.detail-policy-info
.policy-accardion
.detail-payment
.policy-accardion
.accardion-content
.policy-accardion-items-column
.policy-accardion-items-text
.checkbox-wrapper
.policy-accardion-items-text {
  width: 28px;
  height: 28px;
}

.main-user-data
.detail-policy-info
.policy-accardion
.detail-payment
.policy-accardion
.accardion-content
.policy-accardion-items-column
.policy-accardion-items-text
.checkbox-wrapper
.policy-accardion-items-text:after {
  content: "";
  position: absolute;
  top: 2px;
  left: 4px;
  width: 3px;
  height: 6px;
  border-width: 0 2px 2px 0;
  border-style: solid;
  border-color: #b3bdc7;
  opacity: 0.2;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
  -webkit-transition: all 0.1s;
  -o-transition: all 0.1s;
  transition: all 0.1s;
}

@media only screen and (max-width: 579px) {
  .main-user-data
  .detail-policy-info
  .policy-accardion
  .detail-payment
  .policy-accardion
  .accardion-content
  .policy-accardion-items-column
  .policy-accardion-items-text {
    font-size: 8px;
    line-height: 14px;
  }
}

.main-user-data
.detail-policy-info
.policy-accardion
.detail-payment
.policy-accardion
.accardion-content
.policy-accardion-items-header {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: start;
  -webkit-align-items: flex-start;
  -ms-flex-align: start;
  align-items: flex-start;
  margin: 0 24px;
}

.main-user-data
.detail-policy-info
.policy-accardion
.detail-payment
.policy-accardion
.accardion-content
.policy-accardion-items-header
.policy-accardion-items-title {
  font-weight: 700;
  font-size: 20px;
  color: #494e52;
  margin: 0 8px 16px 0;
}

@media only screen and (max-width: 579px) {
  .main-user-data
  .detail-policy-info
  .policy-accardion
  .detail-payment
  .policy-accardion
  .accardion-content
  .policy-accardion-items-header {
    margin: 0;
  }

  .main-user-data
  .detail-policy-info
  .policy-accardion
  .detail-payment
  .policy-accardion
  .accardion-content
  .policy-accardion-items-header
  .policy-accardion-items-title {
    font-size: 10px;
  }
}

.main-user-data
.detail-policy-info
.policy-accardion
.detail-payment
.policy-accardion
.accardion-content
.policy-accardion-items {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: start;
  -webkit-align-items: flex-start;
  -ms-flex-align: start;
  align-items: flex-start;
  margin: 0 24px;
}

.main-user-data
.detail-policy-info
.policy-accardion
.detail-payment
.policy-accardion
.accardion-content
.policy-accardion-items
.policy-accardion-items-text {
  font-weight: 400;
  font-size: 20px;
  color: #494e52;
  line-height: 34px;
  margin: 10px 0;
}

@media only screen and (max-width: 579px) {
  .main-user-data
  .detail-policy-info
  .policy-accardion
  .detail-payment
  .policy-accardion
  .accardion-content
  .policy-accardion-items {
    margin: 0;
  }

  .main-user-data
  .detail-policy-info
  .policy-accardion
  .detail-payment
  .policy-accardion
  .accardion-content
  .policy-accardion-items
  .policy-accardion-items-text {
    font-size: 8px;
    line-height: 14px;
  }
}

.main-user-data
.detail-policy-info
.policy-accardion
.detail-payment
.policy-accardion
.accardion-content
.policy-accardion-items-row-item:nth-child(odd),
.main-user-data
.detail-policy-info
.policy-accardion
.detail-payment
.policy-accardion
.accardion-content
.policy-accardion-items:nth-child(odd) {
  background-color: #f5f5f5;
}

.main-user-data
.detail-policy-info
.policy-accardion
.detail-payment
.policy-accardion
.accardion-content
.submit-btn-block {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: end;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  width: 100%;
  height: auto;
  padding: 0 24px;
}

.main-user-data
.detail-policy-info
.policy-accardion
.detail-payment
.policy-accardion
.accardion-content
.submit-btn-block
.form-status-sending {
  position: relative;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  white-space: nowrap;
  margin-top: 48px;
}

@media only screen and (max-width: 1023px) {
  .main-user-data
  .detail-policy-info
  .policy-accardion
  .detail-payment
  .policy-accardion
  .accardion-content
  .submit-btn-block
  .form-status-sending {
    right: auto;
  }
}

.main-user-data
.detail-policy-info
.policy-accardion
.detail-payment
.policy-accardion
.accardion-content
.submit-btn-block
.form-status-sending
.form-loader {
  width: 36px;
  height: 36px;
  background-image: url(data:image/svg+xml;base64,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);
  -webkit-background-size: cover;
  background-size: cover;
  -webkit-animation: loading 0.5s infinite linear;
  animation: loading 0.5s infinite linear;
}

.main-user-data
.detail-policy-info
.policy-accardion
.detail-payment
.policy-accardion
.accardion-content
.submit-btn-block
.form-status-sending
.form-loader-text {
  font-size: 16px;
  font-weight: 700;
  color: #004b88;
  margin-left: 8px;
}

@keyframes loading {
  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn);
  }
}

.main-user-data
.detail-policy-info
.policy-accardion
.detail-payment
.policy-accardion
.accardion-content
.submit-btn-block
.common-button {
  font-weight: 700;
  font-size: 16px;
  color: #212325;
  line-height: 20px;
  background: #fff;
  border: 1px solid #d4d4d4;
  margin: 24px 0;
}

.main-user-data
.detail-policy-info
.policy-accardion
.detail-payment
.policy-accardion
.accardion-content
.submit-btn-block
.lightblue {
  background-color: #0075d4;
  color: #fff;
}

.main-user-data
.detail-policy-info
.policy-accardion
.detail-payment
.policy-accardion
.accardion-content
.submit-btn-block
.disabled {
  background-color: #b3bdc7;
  color: #fff;
}

@media only screen and (max-width: 579px) {
  .main-user-data
  .detail-policy-info
  .policy-accardion
  .detail-payment
  .policy-accardion
  .accardion-content
  .submit-btn-block {
    padding: 0;
  }
}

.main-user-data .detail-policy-info .policy-accardion .error-container {
  position: fixed;
  z-index: 40;
  top: 0;
  left: 0;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-flow: row nowrap;
  -ms-flex-flow: row nowrap;
  flex-flow: row nowrap;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  -webkit-box-align: start;
  -webkit-align-items: flex-start;
  -ms-flex-align: start;
  align-items: flex-start;
  justify-content: center;
  padding-top: 100px;
  width: 100vw;
  height: 100vh;
  background-color: rgba(33, 35, 37, 0.5);
  overflow-y: auto;
  margin-bottom: 24px;
}

.main-user-data
.detail-policy-info
.policy-accardion
.error-container
.error-title-wrapper {
  width: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  border-width: 0 2px 2px 0;
  border-style: solid;
  border-color: #b3bdc7;
  background-color: #fff;
}

.main-user-data
.detail-policy-info
.policy-accardion
.error-container
.error-title-wrapper
.error-title {
  height: auto;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -webkit-align-items: flex-start;
  -ms-flex-align: start;
  align-items: flex-start;
  margin: 16px 8px;
  font-weight: 400;
  font-size: 20px;
  color: #494e52;
  line-height: 34px;
}

.main-user-data .detail-policy-info .policy-accardion-active {
  height: auto;
}

.main-user-data .detail-policy-info .subgroup .subgroup-title {
  font-size: 24px;
  color: #212325;
  font-weight: 700;
  padding: 24px;
}

@media only screen and (max-width: 768px) {
  .main-user-data .detail-policy-info .subgroup .subgroup-title {
    font-size: 18px;
  }
}

.main-user-data .detail-policy-info .subgroup .doc-wrapper {
  border: 1px solid #e5e5e5;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  text-decoration: none;
}

.main-user-data .detail-policy-info .subgroup .doc-wrapper .left-content {
  margin: 9px;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
}

.main-user-data .detail-policy-info .subgroup .doc-wrapper .left-content .doc-icon {
  width: 28px;
  height: 28px;
  background-image: url(data:image/svg+xml;base64,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);
  background-position: 50%;
  -webkit-background-size: cover;
  background-size: cover;
}

.main-user-data .detail-policy-info .subgroup .doc-wrapper .left-content .doc-text-left {
  margin-left: 9px;
  font-weight: 400;
  font-size: 16px;
  color: #494e52;
  line-height: 18px;
}

@media only screen and (max-width: 579px) {
  .main-user-data .detail-policy-info .subgroup .doc-wrapper .left-content .doc-text-left {
    font-size: 9px;
  }
}

.main-user-data .detail-policy-info .subgroup .doc-wrapper .right-content {
  margin: 9px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.main-user-data .detail-policy-info .subgroup .doc-wrapper .right-content .doc-text-right {
  font-weight: 700;
  font-size: 16px;
  color: #b3bdc7;
  text-align: right;
  margin-right: 5px;
}

.main-user-data .detail-policy-info .subgroup .doc-wrapper .right-content .download-icon {
  width: 20px;
  height: 20px;
  background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTJweCIgaGVpZ2h0PSIxNHB4IiB2aWV3Qm94PSIwIDAgMTIgMTQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUzLjIgKDcyNjQzKSAtIGh0dHBzOi8vc2tldGNoYXBwLmNvbSAtLT4KICAgIDx0aXRsZT5pY29uPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGcgaWQ9Im5ld19yZWdpc3RyYXRpb24iIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJpY29uLXN2Zy9kb3dubG9hZF8yNCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTYuMDAwMDAwLCAtNS4wMDAwMDApIiBmaWxsPSIjQjNCREM3Ij4KICAgICAgICAgICAgPHBhdGggZD0iTTEzLDEwIEwxNS4wNjU3NDE1LDEwIEMxNS4xNjQ0NTM5LDEwIDE1LjI2MDk1NzgsMTAuMDI5MjE5IDE1LjM0MzA5MTYsMTAuMDgzOTc0OSBDMTUuNTcyODU1OSwxMC4yMzcxNTExIDE1LjYzNDk0MjgsMTAuNTQ3NTg1OCAxNS40ODE3NjY2LDEwLjc3NzM1MDEgTDEyLjQxNjAyNTEsMTUuMzc1OTYyMyBDMTIuMzc5NDA3NywxNS40MzA4ODg0IDEyLjMzMjI3NjIsMTUuNDc4MDE5OSAxMi4yNzczNTAxLDE1LjUxNDYzNzMgQzEyLjA0NzU4NTgsMTUuNjY3ODEzNiAxMS43MzcxNTExLDE1LjYwNTcyNjYgMTEuNTgzOTc0OSwxNS4zNzU5NjIzIEw4LjUxODIzMzQsMTAuNzc3MzUwMSBDOC40NjM0Nzc1NiwxMC42OTUyMTYzIDguNDM0MjU4NTUsMTAuNTk4NzEyNSA4LjQzNDI1ODU1LDEwLjUgQzguNDM0MjU4NTUsMTAuMjIzODU3NiA4LjY1ODExNjE3LDEwIDguOTM0MjU4NTUsMTAgTDExLDEwIEwxMSw1LjUgQzExLDUuMjIzODU3NjMgMTEuMjIzODU3Niw1IDExLjUsNSBMMTIuNSw1IEMxMi43NzYxNDI0LDUgMTMsNS4yMjM4NTc2MyAxMyw1LjUgTDEzLDEwIFogTTYsMTguNSBMNiwxNy41IEM2LDE3LjIyMzg1NzYgNi4yMjM4NTc2MywxNyA2LjUsMTcgTDE3LjUsMTcgQzE3Ljc3NjE0MjQsMTcgMTgsMTcuMjIzODU3NiAxOCwxNy41IEwxOCwxOC41IEMxOCwxOC43NzYxNDI0IDE3Ljc3NjE0MjQsMTkgMTcuNSwxOSBMNi41LDE5IEM2LjIyMzg1NzYzLDE5IDYsMTguNzc2MTQyNCA2LDE4LjUgWiIgaWQ9InNoYXBlIj48L3BhdGg+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=);
  background-position: 50%;
  -webkit-background-size: cover;
  background-size: cover;
}

@keyframes cursor-move {
  from {
    transform: translateY(-50%) scale(0);
  }
  to {
    transform: translateY(-50%) scale(1);
  }
}
</style>
